var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalloutsDirectionSetterTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.665 11.335L16.665 14.5077L14.75 16.4227L12.835 14.5077L12.835 11.335L16.665 11.335Z",
    stroke: "black",
    strokeWidth: 1.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 19H19.75",
    stroke: "black",
    strokeWidth: 1.17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalloutsDirectionSetterTop);
export default __webpack_public_path__ + "static/media/callouts-direction-setter-top.f4f7d27ea328f643e3499d59b89f69bc.svg";
export { ForwardRef as ReactComponent };